import React from 'react';
import Typography from '@mui/material/Typography';
import Page, { Section, ExternalLink } from 'layouts/Page';
import { DOMAIN_BASE_SHORT, ROUTES } from 'config/Nav';

/**
 * How to Report Scammers Page
 *
 * Displays information about how to report scammers who impersonate ELEVATOR Media.
 * Provides reporting instructions for Gmail, PayPal, and Cash App.
 *
 * @returns How to Report Scammers page component
 */
const HowToReportScammersPage = () => {
  return (
    <Page
      title="HOW TO REPORT SCAMMERS"
      titleAsLink={ROUTES.SCAMMERS.to}
      seoData={{
        type: 'article',
        data: {
          baseUrl: DOMAIN_BASE_SHORT,
          title: 'How to Report Scammers',
          path: ROUTES.SCAMMERS.to,
          article: {
            tags: ['scam', 'scammers'],
          },
        },
      }}
      showTrendingPosts={false}
      socialMediaVariant="large"
    >
      <div>
        <Typography>
          ELEVATOR Media and its employees will never email or message you for direct
          payments via Paypal, CashApp or other banking services. All ELEVATOR Media
          employees have an official @elevatormag.com email address and will never email
          you from non-elevatormag.com email address about ELEVATOR opportunities or
          services. <strong>DO NOT send ANY payments</strong> to anyone claiming to work
          for ELEVATOR Media. If You receive any emails or messages about paid uploads,
          posts, promo services, <strong>please help us report these scammers</strong> by
          asking for their payment info, screenshotting their emails or messages and
          reporting them to the appropriate service using the methods below.
        </Typography>
      </div>

      <Section header="Gmail">
        <Typography component="span">
          If you receive an email from an @gmail.com email address offering promotional
          services for ELEVATOR you can report them directly to google here:{' '}
          <ExternalLink href="https://support.google.com/mail/contact/abuse">
            https://support.google.com/mail/contact/abuse
          </ExternalLink>
          .
        </Typography>
      </Section>

      <Section header="PayPal">
        <Typography display="block">
          If you receive any emails or messages offering promotional services for ELEVATOR
          asking for Paypal payments you can report their Paypal email directly to Paypal
          by DMing their help twitter or the email address below.
        </Typography>
        <br />
        <Typography component="span">
          Twitter:{' '}
          <ExternalLink href="https://twitter.com/askpaypal">@askpaypal</ExternalLink>
        </Typography>
        <br />
        <Typography component="span">
          Email:{' '}
          <ExternalLink href="mailto:aupviolations@paypal.com">
            aupviolations@paypal.com
          </ExternalLink>
        </Typography>
      </Section>

      <Section header="Cash App">
        <Typography display="block">
          If you receive any emails or messages offering promotional services for ELEVATOR
          asking for CashApp payments you can report their CashApp username directly to
          CashApp by DMing their help twitter.
        </Typography>
        <br />
        <Typography component="span">
          Twitter:{' '}
          <ExternalLink href="https://twitter.com/cashsupport">@cashsupport</ExternalLink>
        </Typography>
      </Section>
    </Page>
  );
};

export default HowToReportScammersPage;
